import { createStyles, keyframes } from "antd-style";

export const useStyles = createStyles(({ css }) => {
  // loading 无限循环实现
  const circle = keyframes`
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    `;
    return {
      // loading 无限循环
      loading: css`
        width: fit-content;
        animation: ${circle} 2s linear infinite;
        will-change: transform;
      `,
    };
}, {
  hashPriority: "low",
});
